import React, { createContext, useContext, useState } from 'react';

const KidsFriendlyContext = createContext();

export const KidsFriendlyProvider = ({ children }) => {
  const [kidsFriendlyFilter, setKidsFriendlyFilter] = useState(false);

  const toggleKidsFriendly = () => {
    setKidsFriendlyFilter(prev => !prev);
  };

  return (
    <KidsFriendlyContext.Provider value={{ 
      kidsFriendlyFilter, 
      setKidsFriendlyFilter,
      toggleKidsFriendly 
    }}>
      {children}
    </KidsFriendlyContext.Provider>
  );
};

export const useKidsFriendly = () => {
  const context = useContext(KidsFriendlyContext);
  if (!context) {
    throw new Error('useKidsFriendly must be used within a KidsFriendlyProvider');
  }
  return context;
};
